import type React from "react";
import GoogleMapReactLib from "google-map-react";

type CompatComponent<P> = (props: P) => React.ReactElement | null;

// google-map-react ships legacy class-component typings that clash with React 18 JSX checks.
const GoogleMapReact =
  GoogleMapReactLib as unknown as CompatComponent<Record<string, unknown>>;

export default GoogleMapReact;
